import { createBrowserRouter } from "react-router-dom"

import { ErrorBoundary } from "@/components/error"
import { AuthLayout, DashboardLayout } from "@/layouts"
import {
  AccessManagementPage,
  CreateOrderPage,
  CreatePaymentConfigurationPage,
  CreateRecurrencePage,
  CustomerDetailsPage,
  CustomerEditPage,
  CustomersPage,
  DashboardPage,
  DefaultersPage,
  FirstLoginPage,
  ForgotPasswordPage,
  LoginPage,
  MerchantDetailPage,
  MerchantMtlsCertificateDetailPage,
  MerchantProcessorDetailPage,
  MerchantProcessorsPage,
  NotificationCenterPage,
  NotificationConfigurationDetailsPage,
  NotificationConfigurationsPage,
  NotificationDetailsPage,
  NotificationProvidersPage,
  NotificationSearchPage,
  NotificationTemplateConfigurationPage,
  NotificationTemplateEditorPage,
  NotificationTemplatesPage,
  OrderDetailsPage,
  OrdersPage,
  PaymentConfigurationDetailPage,
  PaymentConfigurationsPage,
  PaymentMethodDetailPage,
  ProcessorConfigPage,
  RecoveryPasswordPage,
  RepicCenterPage,
  ReprocessPaymentsPage,
  SalesDetailsPage,
  SalesPage,
  ScheduleDetailsPage,
  SchedulePage,
  SmartRoutingConfigurationFormPage,
  SmartRoutingDashboardPage,
  SmartRoutingPage,
  SsoLoginPage,
  SubscriptionDetailsPage,
  SubscriptionsPage,
  WebhookDetailsPage,
  WebhookEditPage,
  WebhookInboxPage,
  WebhooksPage,
  WhiteLabelDetailPage,
  WhiteLabelsPage,
} from "@/pages"
export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <AuthLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        { index: true, element: <LoginPage /> },
        {
          path: "first-login",
          element: <FirstLoginPage />,
        },
        {
          path: "recovery-password",
          element: <RecoveryPasswordPage />,
        },
        {
          path: "forgot-password",
          element: <ForgotPasswordPage />,
        },
        {
          path: "sso-login-form",
          element: <SsoLoginPage />,
        },
      ],
    },
    {
      path: "/",
      element: <DashboardLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        { path: "dashboard", element: <DashboardPage /> },
        {
          path: "access-management",
          element: <AccessManagementPage />,
        },
        { path: "defaulters", element: <DefaultersPage /> },

        { path: "orders", element: <OrdersPage /> },
        {
          path: "orders/details/:orderId",
          element: <OrderDetailsPage />,
        },
        {
          path: "orders/create-order",
          element: <CreateOrderPage />,
        },

        {
          path: "subscriptions",
          element: <SubscriptionsPage />,
        },
        {
          path: "subscriptions/details/:code",
          element: <SubscriptionDetailsPage />,
        },
        {
          path: "subscriptions/create-recurrence",
          element: <CreateRecurrencePage />,
        },

        { path: "sales", element: <SalesPage /> },
        {
          path: "sales/details/:transactionId",
          element: <SalesDetailsPage />,
        },

        { path: "schedule", element: <SchedulePage /> },
        {
          path: "schedule/details/:transactionId",
          element: <ScheduleDetailsPage />,
        },
        { path: "customers", element: <CustomersPage /> },
        {
          path: "customers/details/:customerId",
          element: <CustomerDetailsPage />,
        },
        {
          path: "customers/edit/:customerId",
          element: <CustomerEditPage />,
        },
        { path: "webhooks", element: <WebhooksPage /> },
        {
          path: "repic-center",
          element: <RepicCenterPage />,
        },
        {
          path: "admin/reprocess",
          element: <ReprocessPaymentsPage />,
        },
        {
          path: "webhook-inbox",
          element: <WebhookInboxPage />,
        },
        {
          path: "admin/processors",
          element: <MerchantProcessorsPage />,
        },
        {
          path: "admin/processors/:processorId",
          element: <MerchantProcessorDetailPage />,
        },
        {
          path: "admin/payment-methods/:configId",
          element: <PaymentMethodDetailPage />,
        },
        {
          path: "admin/processor-config",
          element: <ProcessorConfigPage />,
        },
        {
          path: "admin/payment-configurations",
          element: <PaymentConfigurationsPage />,
        },
        {
          path: "admin/payment-configurations/new",
          element: <CreatePaymentConfigurationPage />,
        },
        {
          path: "admin/payment-configurations/:configId",
          element: <PaymentConfigurationDetailPage />,
        },
        {
          path: "admin/white-labels",
          element: <WhiteLabelsPage />,
        },
        {
          path: "admin/white-labels/:uuid",
          element: <WhiteLabelDetailPage />,
        },
        {
          path: "admin/merchant",
          element: <MerchantDetailPage />,
        },
        {
          path: "admin/merchant/certificates/:certificateId",
          element: <MerchantMtlsCertificateDetailPage />,
        },
        {
          path: "webhooks/details/:webhookId",
          element: <WebhookDetailsPage />,
        },
        {
          path: "webhooks/edit/:webhookId",
          element: <WebhookEditPage />,
        },
        {
          path: "notification-center",
          element: <NotificationCenterPage />,
        },
        {
          path: "notification-center/search",
          element: <NotificationSearchPage />,
        },
        {
          path: "notification-center/notifications/:notificationUuid",
          element: <NotificationDetailsPage />,
        },
        {
          path: "notification-center/configurations",
          element: <NotificationConfigurationsPage />,
        },
        {
          path: "notification-center/configurations/:whiteLabelId",
          element: <NotificationConfigurationDetailsPage />,
        },
        {
          path: "notification-center/configurations/:whiteLabelId/providers",
          element: <NotificationProvidersPage />,
        },
        {
          path: "notification-center/configurations/:whiteLabelId/template-configuration/:templateId",
          element: (
            <NotificationTemplateConfigurationPage />
          ),
        },
        {
          path: "notification-center/templates",
          element: <NotificationTemplatesPage />,
        },
        {
          path: "notification-center/templates/:templateUuid",
          element: <NotificationTemplateEditorPage />,
        },
        {
          path: "smart-routing",
          element: <SmartRoutingPage />,
        },
        {
          path: "smart-routing/dashboard",
          element: <SmartRoutingDashboardPage />,
        },
        {
          path: "smart-routing/configurations",
          element: <SmartRoutingPage />,
        },
        {
          path: "smart-routing/configurations/new",
          element: <SmartRoutingConfigurationFormPage />,
        },
        {
          path: "smart-routing/configurations/:uuid",
          element: <SmartRoutingConfigurationFormPage />,
        },
      ],
    },
    {
      path: "*",
      element: <ErrorBoundary />,
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  }
)
